
import { Component, Prop, Vue } from "vue-property-decorator";
import { IBrandGateway } from "@/models/gateways";
import {
  PaymentMethodType,
  SelectedPaymentMethodGatewayOfflinePayment
} from "@/models/selectPaymentMethod";
import { FunctionalComponentOptions } from "vue";

@Component
export default class OfflinePaymentGateway extends Vue {
  // Props
  @Prop({ required: true })
  public brandGateway!: IBrandGateway;

  // Life-cycle methods
  public created() {
    this.$emit("input", {
      type: PaymentMethodType.GATEWAY_OFFLINE,
      data: {
        gateway_id: this.brandGateway.gateway_id
      }
    } as SelectedPaymentMethodGatewayOfflinePayment);
  }

  public render(): FunctionalComponentOptions["render"] {
    return;
  }
}
